module.exports = __webpack_public_path__ + "img/womans.879f81bd.png";